export const ASSET_STATUS = '/api/v1/wallet/sp/user/filter';
export const FIAT_DEPOSIT_INIT = `/api/v1/financial-coordinator/toman/deposit/init`;
export const GET_VSD_BANKS = `/api/v1/user/payment-number`;
